export const visitProposalSent = () => {};

export const visitProposalAccepted = () => {};

export const visitFeedbackSent = () => {};

const visitTrackingEvents = () => ({
  visitProposalSent,
  visitProposalAccepted,
  visitFeedbackSent,
});

export default visitTrackingEvents;
